import React from "react";
import styled from "styled-components";
import { Ban } from "lucide-react";
import { theme } from "@src/theme";
import type { MessagesTab } from "./conversationUtils";

const EmptyStatePanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: ${theme.margins.xl};
  min-height: 0;
`;

const EmptyStateLabel = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: ${theme.colors.gray150};
  text-align: center;
`;

const ChatEmptyStatePanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
`;

const ChatEmptyStateGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 242px;
  min-height: 200px;
  opacity: 0.5;
`;

const ChatEmptyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

const ChatEmptyTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  width: 100%;
`;

const ChatEmptyTitle = styled.h2`
  margin: 0;
  width: 100%;
  font-size: 15.7674px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.02em;
  text-align: center;
  text-transform: uppercase;
  color: ${theme.colors.yellow};
`;

const ChatEmptySubtitle = styled.p`
  margin: 0;
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.02em;
  text-align: center;
  color: ${theme.colors.yellow};
`;

const MessagesEmptyBubbleIcon = (): React.JSX.Element => (
  <svg
    width="90"
    height="72"
    viewBox="0 0 90 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 4H72C75.3137 4 78 6.68629 78 10V44C78 47.3137 75.3137 50 72 50H30L14 64V50H10C6.68629 50 4 47.3137 4 44V10C4 6.68629 6.68629 4 10 4Z"
      stroke={theme.colors.yellow}
      strokeWidth="4"
    />
  </svg>
);

const getSidebarEmptyLabel = (activeTab: MessagesTab): string => {
  switch (activeTab) {
    case "inbox":
      return "No conversations";
    case "requests":
      return "No pending requests";
    case "blocked":
      return "No blocked conversations";
    case "ai_blocked":
      return "No AI blocked conversations";
    case "ended":
      return "No ended conversations";
    default:
      return "No conversations";
  }
};

export const SidebarEmptyState = ({
  activeTab,
}: {
  activeTab: MessagesTab;
}): React.JSX.Element => (
  <EmptyStatePanel>
    <Ban size={56} strokeWidth={1.5} color={theme.colors.gray150} />
    <EmptyStateLabel>{getSidebarEmptyLabel(activeTab)}</EmptyStateLabel>
  </EmptyStatePanel>
);

export const ChatPanelEmptyState = (): React.JSX.Element => (
  <ChatEmptyStatePanel>
    <ChatEmptyStateGroup>
      <ChatEmptyIcon>
        <MessagesEmptyBubbleIcon />
      </ChatEmptyIcon>
      <ChatEmptyTextGroup>
        <ChatEmptyTitle>Your messages</ChatEmptyTitle>
        <ChatEmptySubtitle>Stay connected with the community</ChatEmptySubtitle>
      </ChatEmptyTextGroup>
    </ChatEmptyStateGroup>
  </ChatEmptyStatePanel>
);
